export default __webpack_public_path__ + "static/media/17-Annual-Picnic-2018.fc9369f6.JPG";